import { useState, useEffect } from 'react'
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { FormControl, Grid, InputLabel, Paper, Select } from '@mui/material';
import NotificationBar from '../notification/ServiceNotificationBar';
import { DownloadUserTemplate } from '../../services/DownloadCsvReportsService';
import { UserUpload } from '../../services/LoginPageService';

export default function UserBulkUpload() {
  const [fileUpload, setFileUpload] = useState('');
  const [openNotification, setNotification] = useState({
    status: false,
    type: 'error',
    message: '',
  });

  const onSubmit=(e)=>{
    e.preventDefault();
    UserUpload({
      file:fileUpload
    },handleFacultyBulkService,handleFacultyBulkException);
  }

  const handleFacultyBulkService=(dataObject)=>{
    console.log(dataObject);
    setNotification({
      status: true,
      type: 'success',
      message: dataObject.message,
    });
  }

  const handleFacultyBulkException=(errorStastus, errorMessage)=>{
    setNotification({
      status: true,
      type: 'error',
      message: errorMessage,
    });
  }

  const handleCloseNotify = () => {
    setNotification({
      status: false,
      type: '',
      message: '',
    });
  };

  const onDownload=()=>{
    DownloadUserTemplate(handleDownloadFaculty,handleDownloadFacultyException);
  }

  const handleDownloadFaculty=()=>{}
  const handleDownloadFacultyException=()=>{}
  return (
    <div style={{ height:520 , width: '100%' ,overflow: "scroll"}}>
      <form onSubmit={onSubmit}>
        <Grid container 
        justifyContent="center"
          alignItems="center" spacing={2} style={{ marginTop: '5px'}}>
          <Grid item xs={12} sm={12} md={8} lg={8} lx={8}>
            <Paper elevation={3}>
              <h1 style={{marginTop:'10px',marginBottom:'10px',justifyContent:"center",fontSize:'25px'}}>Import</h1>
              <hr />
              <Grid container spacing={2} style={{ marginTop: '5px' }}>
                <Grid item xs={12} sm={3} md={3} lg={3} xl={3} style={{alignSelf:'center', textAlign:'center' }}>
                <label>Upload CSV File:</label>
                </Grid>
                <Grid item xs={12} sm={7} md={7} lg={7} xl={7} style={{marginTop:'10px',marginBotton:'10px'}}>
                  <TextField
                  fullWidth
                  onChange={(e) => {
                    if (e.target.files && e.target.files.length > 0) {
                      const reader = new FileReader();
                      reader.onload = () => {
                        if (reader.readyState === 2) {
                          setFileUpload(reader.result);
                        }
                      };
                      reader.readAsDataURL(e.target.files[0]);
                    }
                  }}
                  InputLabelProps={{ shrink: true }}
                  type="file"/> 
                </Grid>
              </Grid>
              <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={3.5} md={3.5} lg={3.5} xl={3.5} style={{marginTop:'15px',marginBottom:'20px'}}>
                <Button variant="contained"  component="label" onClick={onDownload}>     
                  Download Templete
                </Button>
                </Grid>
                <Grid item xs={12} sm={2} md={2} lg={2} xl={2} style={{marginTop:'15px',marginBottom:'20px'}}>
                <Button type="submit" variant="contained">Upload</Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </form>
      <NotificationBar
      handleClose={handleCloseNotify}
      notificationContent={openNotification.message}
      openNotification={openNotification.status}
      type={openNotification.type}/>
    </div>     
  )
}
